/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import Confirm from "vux/src/components/confirm/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import XDialog from "vux/src/components/x-dialog/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import Group from "vux/src/components/group/index.vue";
import CheckIcon from "vux/src/components/check-icon/index.vue";
import { mapState, mapMutations } from 'vuex';
import BottomOptions from '@/components/BottomOptions';
import { acceptOrder, getEditOrderDetail, checkFinish, finishOrder, saveCCUsers, startService, getServiceAmount, acceptance, updateOrderGroupId, cancelOrder, workerBespokeDate, printOrder, applyAbnormalOrder, changeOrderAbnormalState, refuseOrder, orderExamine, applyEndService, setOrdervisitUserGrab as _setOrdervisitUserGrab, setOrderRevokeGrab as _setOrderRevokeGrab, saveOrderArchive, getEnterprise, putReduction, deleteOrder, exportOrderPdf } from '@/api';
import OrderExecute from './OrderExecute';
export default {
  components: {
    Assign: function Assign() {
      return import('./Assign');
    },
    Dispatch: function Dispatch() {
      return import('./Dispatch');
    },
    MakeTag: function MakeTag() {
      return import('./MakeTag');
    },
    OrderMessage: function OrderMessage() {
      return import('./OrderMessage');
    },
    OrderExecute: OrderExecute,
    // CreateOrderPopup: () => import('@/package/order/entry/components/CreateOrderPopup'),
    CheckUser: function CheckUser() {
      return import('@/components/CheckUser');
    },
    TpDialog: function TpDialog() {
      return import('@/components/NewVuxComponents/TpDialog');
    },
    Confirm: Confirm,
    BottomOptions: BottomOptions,
    XDialog: XDialog,
    XTextarea: XTextarea,
    Group: Group,
    CheckIcon: CheckIcon
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    orderId: String,
    orderInfo: Object,
    coordList: Array,
    ccList: Array,
    isCollaboratorView: Number,
    orderServiceNodes: Array,
    abnormalOrder: Object,
    isServiceAmount: Boolean,
    // 显示服务款项
    is_view_settlement: [String, Number],
    moneyItemEditRoles: Array,
    // 可使用编辑款项角色
    examineUsers: Array,
    // 审批人员
    examineRoles: Array,
    // 审批人角色
    template: Object // 模板信息

  },
  data: function data() {
    return {
      isAssign: true,
      isMainPersonEditCount: false,
      isCollaboratorEditCount: false,
      applycancle: true,
      applydispatch: false,
      cause: '',
      evalpic: '',
      cancelOrderForm: {
        orderId: '',
        cancelCause: '',
        isReturnSpare: '0'
      },
      dealAbnormalShow: false,
      evaluateShow: false,
      showEvalPic: false,
      showEvalPicInner: true,
      assignShow: false,
      dispatchShow: false,
      messageShow: false,
      tagShow: false,
      executeShow: false,
      createOrderPopupShow: false,
      checkUserModal: false,
      isShowPutIntoGrabModal: false,
      // 投入公海弹窗
      formData: {},
      appointmentShow: false,
      editCountShow: false,
      service: {},
      sparePartList: [],
      moneyItemList: [],
      serviceAmountPopupShow: false,
      showConfirm: false,
      title: '',
      selecttime: this.orderInfo.estimateArriveTime || new Date().Format('YYYY-MM-DD HH:mm'),
      abnormalShow: false,
      isStartService: true,
      isEndServiceL: true,
      isShowExamineModal: false,
      // 审批弹窗
      examineReason: '',
      // 审批原因
      isShowRefuseOrderModal: false,
      // 拒绝工单
      refuseRemark: '' // 拒绝原因

    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user', 'config'])), {}, {
    isInside: function isInside() {
      return this.orderInfo.order_sponsor_type === 2;
    },
    isServiceOption: function isServiceOption() {
      var _this2 = this;

      if (this.$oauth('01027')) {
        return true;
      }

      return this.$oauth('01008') && [4].indexOf(this.orderInfo.state) !== -1 && (this.user.id === this.orderInfo.fk_t_visit_user_id || this.coordList.some(function (item) {
        return item.id === _this2.user.id;
      }));
    },
    // 服务评价
    isGeneralEvaluate: function isGeneralEvaluate() {
      return [5].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01003') && this.orderInfo.evaluate_state === 0 && this.orderInfo.order_sponsor_type === 2 && this.orderInfo.fk_t_take_order_user_id === this.user.id;
    },
    // 投入公海
    isCanPutIntoGrab: function isCanPutIntoGrab() {
      return (this.isassign || this.isreassign || this.designate) && this.orderInfo.is_grab === 1;
    },
    // 捞回
    isCanRevokeGrab: function isCanRevokeGrab() {
      return this.orderInfo.order_is_grab === 1 && this.$oauth('01006');
    },
    // 打标
    istagShow: function istagShow() {
      return this.$oauth('01002') || this.$oauth('01004');
    },
    // 抄送
    isccShow: function isccShow() {
      return this.$oauth('01028');
    },
    // 编辑工单
    iseditOrder: function iseditOrder() {
      if (this.$oauth('01004')) {
        // 对账前
        return this.orderInfo.reconcile_state === 0;
      } else {
        return false;
      }
    },
    isMainOrCoor: function isMainOrCoor() {
      return this.coordList.map(function (v) {
        return v.id;
      }).includes(this.user.id) || this.orderInfo.fk_t_visit_user_id === this.user.id;
    },
    // 转派团队
    isdispatchGroup: function isdispatchGroup() {
      return [1, 2, 3, 4].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.order_is_grab !== 1 && // 未进入公海
      this.$oauth('01007');
    },
    // 拒绝工单
    isrefuseOrder: function isrefuseOrder() {
      return [2].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01008') && this.user.id === this.orderInfo.fk_t_visit_user_id && this.orderInfo.is_worker_refuse_order === 1;
    },
    // 添加进度
    isaddProcess: function isaddProcess() {
      return this.isServiceOption && this.orderServiceNodes && this.orderServiceNodes.length;
    },
    // 受理工单
    isreceiveOrder: function isreceiveOrder() {
      return [0].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.examine_type === 0 && // 不处在 审批环节
      this.$oauth('01005');
    },
    // 取消工单
    isothercancelOrder: function isothercancelOrder() {
      return [1].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01013');
    },
    // 指派工单
    isassign: function isassign() {
      return [1].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.order_is_grab !== 1 && // 未进入公海
      this.$oauth('01006');
    },
    // 重新指派
    isreassign: function isreassign() {
      return [2].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01006');
    },
    // 改派工单
    designate: function designate() {
      return [3, 4].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01006');
    },
    // 接单
    isaccept: function isaccept() {
      return [2].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01008') && this.user.id === this.orderInfo.fk_t_visit_user_id;
    },
    // 预约
    isappointment: function isappointment() {
      return [3].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01008') && this.user.id === this.orderInfo.fk_t_visit_user_id && this.orderInfo.is_appointment === 1 && // 模板开启预约流程
      this.orderInfo.appoint_state === 0 // 工单预约状态
      ;
    },
    // 修改预约时间
    isEditAppointmentTime: function isEditAppointmentTime() {
      return [0, 1, 2, 3, 4].indexOf(this.orderInfo.state) !== -1 && this.template.appointmentView === 1 && //  模板开启预约字段
      this.$oauth('01016');
    },
    // 修改预约时间
    isServerAppointmentTime: function isServerAppointmentTime() {
      return false; // (
      //   [2, 3].indexOf(this.orderInfo.state) !== -1 &&
      //   this.user.id === this.orderInfo.fk_t_visit_user_id &&
      //   this.template.appointmentView === 1 &&
      //   this.orderInfo.is_appointment === 0
      // )
    },
    // 工单归档
    isOrderArchive: function isOrderArchive() {
      return [5].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01018') && this.orderInfo.place_state === 0;
    },
    // 开始服务
    isstartService: function isstartService() {
      return [3].indexOf(this.orderInfo.state) !== -1 && this.$oauth('01008') && this.user.id === this.orderInfo.fk_t_visit_user_id && (this.orderInfo.is_appointment === 0 || this.orderInfo.is_appointment === 1 && this.orderInfo.appoint_state === 1);
    },
    // 结束服务
    isfinishOrder: function isfinishOrder() {
      return [4].indexOf(this.orderInfo.state) !== -1 && this.user.id === this.orderInfo.fk_t_visit_user_id && this.$oauth('01008');
    },
    iseditCount: function iseditCount() {
      this.moneyItemEditRoles = this.moneyItemEditRoles || [];
      var moneyItemEditRoles = this.moneyItemEditRoles.concat([{
        fk_t_ep_role_id: 3
      }]);
      var rolelist = moneyItemEditRoles.map(function (item) {
        return item.fk_t_ep_role_id;
      }).includes(this.user.sysrole);
      var isCoopCanView = this.isCollaboratorView && this.orderInfo.coordination_user_id && this.orderInfo.coordination_user_id.split(',').map(Number).includes(this.user.id);
      var isOrderOver = this.orderInfo.state === 5 && this.orderInfo.is_create_settlement === 1;
      var is_receipt = this.orderInfo.is_receipt; // 是否开启工单回执

      var is_create_settlement = this.orderInfo.is_create_settlement; // 是否开启收款

      var is_create_receipt = this.orderInfo.is_create_receipt; // 是否填写回执

      var is_settlement = this.orderInfo.is_settlement; // 是否收款

      var is_order_charge = this.orderInfo.is_order_charge; // 是否开启服务款项

      var is_create_charge = this.orderInfo.is_create_charge; // 是否填写过服务款项

      var state5 = this.orderInfo.state === 5 && (is_receipt === 1 && is_create_receipt === 0 || is_receipt === 0 && is_create_settlement === 1 && is_settlement === 0 || is_receipt === 0 && is_create_settlement === 0 && is_order_charge === 1 && is_create_charge === 0);
      var isMain = this.user.id === this.orderInfo.fk_t_visit_user_id && this.isMainPersonEditCount;
      var isColl = isCoopCanView && this.isCollaboratorEditCount;
      return Boolean(this.orderInfo.is_order_charge === 1 && // 是否开启服务款项
      !isOrderOver && ( // 工单结算
      (isMain || isColl) && ([3, 4].includes(this.orderInfo.state) || state5) || rolelist && ([1, 2, 3, 4].indexOf(this.orderInfo.state) !== -1 || state5)));
    },
    // 工单回执
    iscallReceipt: function iscallReceipt() {
      // ((this.orderInfo.is_create_charge === 1 &&
      //   this.is_view_settlement === 1) ||
      //   this.is_view_settlement === 0) &&
      return this.$oauth('01008') && this.user.id === this.orderInfo.fk_t_visit_user_id && [5].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.is_create_receipt === 0 && (!this.orderInfo.fk_t_ep_ordertype_tmpl_id || this.orderInfo.is_receipt === 1 || this.orderInfo.fk_t_ep_ordertype_tmpl_id === -1);
    },
    // 服务收款
    isserviceAmount: function isserviceAmount() {
      var orderInfo = this.orderInfo;
      return [5].indexOf(orderInfo.state) !== -1 && this.$oauth('01008') && this.user.id === orderInfo.fk_t_visit_user_id && (orderInfo.is_order_charge === 1 && orderInfo.is_create_charge === 1 || orderInfo.is_order_charge === 0) && ( // 关闭款项 或 （开启服务款项并填写）
      orderInfo.is_receipt === 1 && orderInfo.is_create_receipt === 1 || orderInfo.is_receipt === 0) && // 关闭回执 或 （开启工单回执并填写）
      orderInfo.is_settlement === 1 && orderInfo.is_create_settlement === 0; // 开启收款 并 未结算
    },
    // 异常处理
    isdealAbnormal: function isdealAbnormal() {
      return this.$oauth('01011') && this.orderInfo.abnormal_state === 1;
    },
    // 设为无效
    issetInvalid: function issetInvalid() {
      return this.$oauth('01005') && [0].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.is_refuse_acceptance === 0 && this.orderInfo.is_createorder_examine !== 1 && this.orderInfo.examine_submit_state !== 1;
    },
    // 编辑工单
    issyseditOrder: function issyseditOrder() {
      return this.$oauth('01004') && [0, 1, 2, 3, 4, 5, 6].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.order_sponsor_type !== 2;
    },
    // 取消工单
    iscancelOrder: function iscancelOrder() {
      return this.$oauth('01013') && [1, 2, 3, 4].indexOf(this.orderInfo.state) !== -1;
    },
    // 申请异常
    issetAbnormal: function issetAbnormal() {
      return this.$oauth('01010') && this.user.id === this.orderInfo.fk_t_visit_user_id && [3, 4].indexOf(this.orderInfo.state) !== -1 && this.orderInfo.abnormal_state === 0;
    },
    // 工单打印
    isprintOrder: function isprintOrder() {
      return this.$oauth('01014');
    },
    // 是否开启审批
    isCreateExamineState: function isCreateExamineState() {
      return this.orderInfo.is_createorder_examine === 1 && this.orderInfo.state === 0;
    },
    // 服务完成 审批
    isServiceExamineState: function isServiceExamineState() {
      return this.orderInfo.is_service_examine === 1 && this.orderInfo.state === 4;
    },
    // 提交审批按钮
    isShowSubmitExamine: function isShowSubmitExamine() {
      return this.isCreateExamineState && // 创建审批
      this.orderInfo.examine_submit_state === 0 && // 未提交
      this.$oauth('01004');
    },
    // 审批按钮
    isShowExamine: function isShowExamine() {
      var examineUsers = this.examineUsers ? this.examineUsers.map(function (item) {
        return item.fk_t_ep_user_id;
      }) : [];
      var examineRoles = this.examineRoles ? this.examineRoles.map(function (item) {
        return item.role_type;
      }).join(',') : '';
      return this.$oauth('01001') && (this.isCreateExamineState || this.isServiceExamineState) && // 开启审批
      this.orderInfo.examine_submit_state === 1 && ( // 已提交
      examineUsers.indexOf(this.user.id) !== -1 || examineRoles && (this.orderInfo.fk_t_dispatch_user_id || this.orderInfo.fk_t_take_order_user_id) || !this.orderInfo.fk_t_dispatch_user_id && this.user.sysrole === 1 && (!this.orderInfo.groupId && this.user.groups && this.user.groups.length === 0 || this.user.groups && this.user.groups.map(function (v) {
        return v.groupId;
      }).includes(this.orderInfo.groupId))); // 可审批用户
    },
    // 服务人员 是否可抢单
    isCanGrab: function isCanGrab() {
      return this.$oauth('01008') && (this.orderInfo.state === 1 || this.orderInfo.state === 2) && // 待指派 待接单
      this.orderInfo.order_is_grab === 1; // 抢单池
    },
    bottomLeft: function bottomLeft() {
      var list = [];

      if (this.$oauth('01001')) {
        list.push({
          name: 'message',
          text: '留言',
          icon: 'message32_30@3x'
        });
      }

      if (this.istagShow) {
        list.push({
          name: 'tag',
          text: '打标',
          icon: 'edittag28_32@3x'
        });
      }

      if (this.isccShow) {
        list.push({
          name: 'cc',
          text: '抄送',
          icon: 'copy28_32@3x'
        });
      }

      return list;
    },
    bottomRight: function bottomRight() {
      var list = [];
      var state = this.orderInfo.state; // 工单已删除

      if (this.orderInfo.is_deleted) {
        list.push({
          name: 'reduction',
          text: '还原工单'
        });
        return list;
      } // "0待受理",
      // "1待指派",
      // "2待接单",
      // "3待服务",
      // "4服务中",
      // "5已完成",
      // "6已取消"


      if (state === 0) {
        if (this.isreceiveOrder) {
          list.push({
            name: 'receiveOrder',
            text: '受理工单'
          });
        }

        if (this.isShowExamine) {
          list.push({
            name: 'orderExamine',
            text: '审批'
          });
        }
      }

      if (state === 1) {
        if (this.isassign) {
          list.push({
            name: 'assign',
            text: '指派人员'
          });
        }
      }

      if (state === 2) {
        if (this.isrefuseOrder) {
          list.push({
            name: 'refuseOrder',
            text: '拒绝工单'
          });
        }

        if (this.isaccept) {
          list.push({
            name: 'accept',
            text: '接收工单'
          });
        }

        if (this.isCanGrab) {
          list.push({
            name: 'grab',
            text: '抢单'
          });
        }
      }

      if (state === 3) {
        if (this.isstartService) {
          list.push({
            name: 'startService',
            text: '开始服务'
          });
        }

        if (this.isdealAbnormal) {
          list.push({
            name: 'dealAbnormal',
            text: '异常处理'
          });
        }

        if (this.isappointment) {
          list.push({
            name: 'appointment',
            text: '预约上门'
          });
        }
      }

      if (state === 4) {
        if (this.isShowExamine) {
          list.push({
            name: 'orderExamine',
            text: '审批'
          });
        }

        if (this.isfinishOrder) {
          list.push({
            name: 'finishOrder',
            text: '服务完成'
          });
        }

        if (this.isaddProcess) {
          list.push({
            name: 'addProcess',
            text: '添加进度'
          });
        }

        if (this.isdealAbnormal) {
          list.push({
            name: 'dealAbnormal',
            text: '异常处理'
          });
        }
      }

      if (state === 5) {
        if (this.iseditCount) {
          list.push({
            name: 'editCount',
            text: '编辑款项'
          });
        }

        if (this.iscallReceipt) {
          list.push({
            name: 'callReceipt',
            text: '工单回执'
          });
        }

        if (this.isserviceAmount) {
          list.push({
            name: 'serviceAmount',
            text: '服务收款'
          });
        }

        if (this.isGeneralEvaluate) {
          list.push({
            name: 'serviceEval',
            text: '服务评价'
          });
        }
      }

      if (state === 6) {} // if (this.isdispatchGroup) {
      //   list.push({
      //     name: 'dispatchGroup',
      //     text: '转派团队'
      //   })
      // }


      return list;
    },
    // 钉钉右上角菜单栏
    menuList: function menuList() {
      var list = [];

      if (this.isaddProcess) {
        list.push({
          id: 'addProcess',
          text: '添加进度'
        });
      }

      if (this.isreassign) {
        list.push({
          id: 'reassign',
          text: '重新指派'
        });
      }

      if (this.isCanRevokeGrab) {
        list.push({
          id: 'revokeGrab',
          text: '捞回工单'
        });
      }

      if (this.isCanPutIntoGrab) {
        list.push({
          id: 'putIntoGrab',
          text: '投入公海'
        });
      }

      if (this.isothercancelOrder) {
        list.push({
          id: 'othercancelOrder',
          text: '取消工单'
        });
      }

      if (this.isdispatchGroup) {
        list.push({
          id: 'dispatchGroup',
          text: '转派团队'
        });
      } // 角色：系统、派单  工单状态：待服务、服务中


      if (this.designate) {
        list.push({
          id: 'designate',
          text: '改派工单'
        });
      } // 角色：系统、受理  工单状态：待受理


      if (this.issetInvalid) {
        list.push({
          id: 'setInvalid',
          text: '设为无效'
        });
      } // 角色：系统、派单、业务员  工单状态：待指派、未接单、待服务
      // 角色：系统  工单状态：全部状态


      if (!this.isShowSubmitExamine && this.iseditOrder) {
        list.push({
          id: 'editOrder',
          text: '编辑工单'
        });
      } // 角色：系统、派单  工单状态：待指派、未接单、待服务、服务中


      if (this.iscancelOrder) {
        list.push({
          id: 'cancelOrder',
          text: '取消工单'
        });
      } // 角色：服务人员  工单状态：待服务、服务中


      if (this.issetAbnormal) {
        list.push({
          id: 'setAbnormal',
          text: '申请异常'
        });
      } // 角色：服务人员、系统管理员  工单状态：待服务、服务中


      if (this.isprintOrder) {
        list.push({
          id: 'printOrder',
          text: '工单打印'
        });
      }

      if (this.iseditCount) {
        list.push({
          id: 'editSettlement',
          text: '编辑款项'
        });
      } // 角色：系统管理员、派单员
      // 工单状态：待受理、待指派、待接单状态时


      if (this.isEditAppointmentTime || this.isServerAppointmentTime) {
        list.push({
          id: 'editAppointmentTime',
          text: '修改预约时间'
        });
      } // 角色：系统管理员
      // 工单状态：已完成


      if (this.isOrderArchive) {
        list.push({
          id: 'orderArchive',
          text: '工单归档'
        });
      }

      if (this.$oauth('01019')) {
        list.push({
          id: 'deleteOrder',
          text: '删除工单'
        });
      }

      return list;
    },
    // 判断 新预约时间是否 与 客户预约时间 相同
    isTimeSame: function isTimeSame() {
      if (!this.selecttime || !this.orderInfo.estimateArriveTime) return false;
      var reg = /\d{4}-\d\d-\d\d\s\d\d:\d\d/g;
      return this.orderInfo.estimateArriveTime.match(reg)[0] === this.selecttime.match(reg)[0];
    }
  }),
  watch: {
    'orderInfo.state': {
      handler: function handler() {
        this.updateMenuList();
      }
    },
    createOrderPopupShow: function createOrderPopupShow(val) {
      var _this3 = this;

      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this3.createOrderPopupShow = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    dealabnormalShowOnConfirm: function dealabnormalShowOnConfirm() {
      var _this4 = this;

      var data = {
        orderId: this.orderId,
        type: this.abnormalOrder.type,
        state: 2
      };
      changeOrderAbnormalState(data).then(function (res) {
        if (res.success) {
          _this4.$vux.toast.text('同意成功');

          _this4._pageReload({
            order: true // 工单列表

          });

          _this4.dealAbnormalShow = false;

          _this4.$emit('on-success');
        } else {
          _this4.$vux.toast.text('同意失败');

          _this4.dealAbnormalShow = false;
        }
      });
      this.$point('ORD0011');
    },
    cancleabnormalShowOnConfirm: function cancleabnormalShowOnConfirm() {
      var _this5 = this;

      var data = {
        orderId: this.orderId,
        type: this.abnormalOrder.type,
        state: 1
      };
      changeOrderAbnormalState(data).then(function (res) {
        if (res.success) {
          _this5.$vux.toast.text('驳回成功');

          _this5._pageReload({
            order: true // 工单列表

          });

          _this5.dealAbnormalShow = false;

          _this5.$emit('on-success');
        } else {
          _this5.$vux.toast.text('驳回失败');

          _this5.dealAbnormalShow = false;
        }
      });
      this.$point('ORD0011');
    },
    abnormalShowOnConfirm: function abnormalShowOnConfirm() {
      var _this6 = this;

      if (this.cause.trim() === '') {
        this.$vux.toast.text("\u8BF7\u8F93\u5165\u7533\u8BF7\u539F\u56E0");
      } else {
        var data = {
          orderId: this.orderId,
          type: this.applycancle ? 1 : 2,
          applyReason: this.cause
        };
        applyAbnormalOrder(data).then(function (res) {
          if (res.success) {
            _this6.$vux.toast.text('申请成功');

            _this6.abnormalShow = false;

            _this6.$emit('on-success');
          } else {
            _this6.$vux.toast.text(res.message);
          }
        });
      }
    },
    applycancleClick: function applycancleClick() {
      this.applycancle = !this.applycancle;
      this.applydispatch = !this.applydispatch;
    },
    applyDispatch: function applyDispatch() {
      this.applycancle = !this.applycancle;
      this.applydispatch = !this.applydispatch;
    },
    timeselect: function timeselect() {
      // 组件内使用
      var value = this.selecttime || this.orderInfo.estimateArriveTime;
      value = value ? value.match(/^[-\d]{10}\s[:\d]{5}/)[0] : '';

      var _this = this;

      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        startDate: new Date().Format('YYYY-MM-DD'),
        format: 'YYYY-MM-DD HH:mm',
        value: value,
        onConfirm: function onConfirm(val) {
          val = val + ':00';
          _this.selecttime = val;
        },
        onShow: function onShow() {// console.log('plugin show')
        },
        onHide: function onHide() {// console.log('plugin hide')
        }
      });
    },
    onConfirm: function onConfirm(value) {
      var _this7 = this;

      var func = cancelOrder;

      if (value.trim() === '') {
        this.$vux.toast.text("\u8BF7\u8F93\u5165\u53D6\u6D88\u539F\u56E0");
        return;
      }

      var cancelOrderForm = {
        orderId: this.orderId,
        cancelCause: value,
        isReturnSpare: '0'
      };
      func(cancelOrderForm).then(function (res) {
        if (res.success) {
          _this7.$vux.toast.text('取消工单成功');

          _this7.showConfirm = false;

          _this7.$emit('on-success');
        } else {
          _this7.$vux.toast.text(res.message);
        }
      });
      this.$point('ORD0016');
    },
    // 工单归档
    orderArchiveFuc: function orderArchiveFuc() {
      var _this8 = this;

      var data = {
        orderId: this.orderId
      };
      saveOrderArchive(data).then(function (res) {
        if (res.success) {
          _this8.$vux.toast.text('归档成功');

          _this8.$emit('on-success-callBack');
        } else {
          _this8.$vux.toast.text(res.message);
        }
      });
    },
    // 更新钉钉右上角的菜单
    updateMenuList: function updateMenuList() {
      var _this9 = this;

      if (!this.$DingTalk || this.orderInfo.is_deleted) return;

      if (this.menuList.length > 0) {
        this.$DingTalk && this.$DingTalk.biz.navigation.setMenu({
          items: this.menuList,
          onSuccess: function onSuccess(_ref) {
            var id = _ref.id;

            if (id === 'addProcess') {
              if (_this9.orderServiceNodes.length === 0) {
                _this9.$vux.toast.text('没有需要填写的进度');
              } else {
                _this9.$router.push({
                  name: 'WriteProgress',
                  params: {
                    orderId: _this9.orderId
                  }
                });
              }
            }

            if (id === 'deleteOrder') {
              _this9.$vux.confirm.show({
                content: '<span>确认删除工单？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  deleteOrder({
                    oid: _this9.orderId
                  }).then(function (res) {
                    if (res.success) {
                      _this9.$vux.toast.text('删除工单成功');

                      _this9.$emit('on-success');

                      _this9._pageReload({
                        order: true
                      });
                    } else {
                      _this9.$vux.toast.text(res.message);
                    }
                  });
                }
              });
            }

            if (id === 'reassign') {
              _this9.isAssign = false;
              _this9.assignShow = true;
            }

            if (id === 'revokeGrab') {
              _this9.setOrderRevokeGrab(_this9.orderInfo.orderId);
            }

            if (id === 'putIntoGrab') {
              _this9.isShowPutIntoGrabModal = true;
            }

            if (id === 'othercancelOrder') {
              _this9.$vux.confirm.show({
                content: '<span>确认取消工单？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  _this9.showConfirm = true;
                }
              });
            }

            if (id === 'dispatchGroup') {
              _this9.dispatchShow = true;
            }

            if (id === 'editOrder') {
              // 编辑工单
              _this9.getEditOrderDetailFunc();
            } else if (id === 'setInvalid') {
              // 设为无效
              _this9.$vux.confirm.show({
                content: '<span>确认设为无效？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  acceptance({
                    orderId: _this9.orderId,
                    type: 2
                  }).then(function (res) {
                    if (res.success) {
                      _this9.$vux.toast.text('设为无效成功');

                      _this9._pageReload({
                        order: true // 工单列表

                      });

                      _this9.$router.go(-1);

                      _this9.$emit('on-success');
                    } else {
                      _this9.$vux.toast.text(res.message);
                    }
                  });
                }
              });

              _this9.$point('ORD0007');
            } else if (id === 'cancelOrder') {
              var _this = _this9;

              _this9.$vux.confirm.show({
                content: '<span>确认取消工单？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  _this.showConfirm = true;
                }
              });
            } else if (id === 'setAbnormal') {
              var _this10 = _this9;

              _this9.$vux.confirm.show({
                content: '<span>确认申请异常？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  _this10.abnormalShow = true;
                }
              });
            } else if (id === 'printOrder') {
              // 打印工单
              _this9.$vux.confirm.show({
                content: '<span>确认打印工单？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  var _this = _this9;

                  _this9.$DingTalk.runtime.permission.requestOperateAuthCode({
                    corpId: _this.config.corpId,
                    agentId: _this.config.agentid,
                    onSuccess: function onSuccess(result) {
                      exportOrderPdf({
                        oids: [_this.orderId]
                      }).then(function (res) {
                        if (res.success) {
                          _this.$vux.toast.text('工单打印成功, 前往PC端下载中心，进行下载');
                        } else {
                          _this.$vux.toast.text(res.message);
                        }
                      });
                    },
                    onFail: function onFail(err) {
                      alert(JSON.stringify(err));
                    }
                  });

                  _this9.$point('ORD0020');
                }
              });
            } else if (id === 'editSettlement') {
              _this9.editCountShow = true;
            } else if (id === 'editAppointmentTime') {
              _this9.appointmentShow = true;
            } else if (id === 'designate') {
              _this9.isAssign = false;
              _this9.assignShow = true;
            } else if (id === 'orderArchive') {
              var _this11 = _this9;

              _this9.$vux.confirm.show({
                content: '<span>确认对此工单归档？</span>',
                onCancel: function onCancel() {},
                onConfirm: function onConfirm() {
                  _this11.orderArchiveFuc();
                }
              });
            }
          }
        });
      } else {
        this.$DingTalk && this.$DingTalk.biz.navigation.setRight({
          show: false
        });
      }
    },
    onClick: function onClick(name) {
      var _this12 = this;

      if (name === 'reduction') {
        this.$vux.confirm.show({
          content: '<span>确认还原已删除工单？</span>',
          onCancel: function onCancel() {},
          onConfirm: function onConfirm() {
            if (_this12.$oauth('01020')) {
              putReduction({
                ids: _this12.orderId,
                fk_t_enterprise_id: _this12.user.cropId
              }).then(function (res) {
                if (res.success) {
                  _this12.$vux.toast.text('还原工单成功');

                  _this12.$emit('on-success');

                  _this12._pageReload({
                    order: true // 工单列表

                  });
                } else {
                  _this12.$vux.toast.text(res.message);
                }
              });
            } else {
              _this12.$vux.toast.text('无权限');
            }
          }
        });
      }

      if (name === 'receiveOrder') {
        // 受理工单
        this.$vux.confirm.show({
          content: '<span>确认受理工单？</span>',
          onCancel: function onCancel() {},
          onConfirm: function onConfirm() {
            acceptance({
              orderId: _this12.orderId,
              type: 1
            }).then(function (res) {
              if (res.success) {
                _this12.$vux.toast.text('受理工单成功');

                _this12.$emit('on-success');

                _this12._pageReload({
                  order: true // 工单列表

                });
              } else {
                _this12.$vux.toast.text(res.message);
              }
            });

            _this12.$point('ORD0007');
          }
        });
      } else if (name === 'refuseOrder') {
        // 受理工单
        this.isShowRefuseOrderModal = true; // this.$vux.confirm.show({
        //   content: '<span>确认拒绝工单？</span>',
        //   onCancel: () => {
        //   },
        //   onConfirm: () => {
        //     refuseOrder({
        //       oid: this.orderId
        //     }).then(res => {
        //       if (res.success) {
        //         this.$vux.toast.text('拒绝工单成功')
        //         this.$emit('on-success')
        //       } else {
        //         this.$vux.toast.text(res.message)
        //       }
        //     })
        //     this.$point('ORD0022')
        //   }
        // })
      } else if (name === 'othercancelOrder') {
        var _this = this;

        this.$vux.confirm.show({
          content: '<span>确认取消工单？</span>',
          onCancel: function onCancel() {},
          onConfirm: function onConfirm() {
            _this.showConfirm = true;
          }
        });
      } else if (name === 'assign') {
        // 指派人员
        this.isAssign = true;
        this.assignShow = true;
      } else if (name === 'reassign') {
        // 重新指派
        this.isAssign = false;
        this.assignShow = true;
      } else if (name === 'dispatchGroup') {
        // 转派团队
        this.dispatchShow = true;
      } else if (name === 'appointment') {
        this.appointmentShow = true;
      } else if (name === 'startService') {
        if (!this.isStartService) return;
        if (!this.orderInfo) return;

        if (this.orderInfo.is_sign_location === 0 || process.env.NODE_ENV === 'development') {
          var params = {
            orderId: this.orderId,
            longitude: 0,
            latitude: 0,
            distance: -1
          };
          this.startOrEndService(startService, params, '是否开始服务？', '开始服务');
          return;
        }

        this.isStartService = false; // 先定位计算距离

        this.$vux.loading.show({
          text: '定位中...'
        });
        this.$DingTalk.device.geolocation.get({
          targetAccuracy: 100,
          // 精度半径
          coordinate: 1,
          // 1 高德坐标 2 标准坐标（无address字段）
          withReGeocode: true,
          // 是否返回逆地理编码信息
          useCache: true,
          // 是否缓存（开启后2分钟内再次请求返回缓存信息）
          onSuccess: function onSuccess(_ref2) {
            var longitude = _ref2.longitude,
                latitude = _ref2.latitude,
                address = _ref2.address;
            var distance = -1;
            var text = '';

            if (longitude && latitude && address) {
              // 获取客户经纬度
              var customLatitude = _this12.orderInfo.custom_latitude;
              var customLongitude = _this12.orderInfo.custom_longitude; // 计算距离

              var PI = Math.PI;
              var EARTH_RADIUS = 6378137.0;

              var getRad = function getRad(d) {
                return d * PI / 180.0;
              };

              var getDistance = function getDistance(lng1, lat1, lng2, lat2) {
                if (lng2 === null || lng2 === '' || lng2 === 'null') {
                  return -1;
                }

                var radLat1 = getRad(lat1);
                var radLat2 = getRad(lat2);
                var a = radLat1 - radLat2;
                var b = getRad(lng1) - getRad(lng2);
                var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
                s = s * EARTH_RADIUS;
                s = Math.round(s * 10000) / 10000.0;
                s = Math.round(s);
                return s;
              };

              distance = getDistance(customLongitude, customLatitude, longitude, latitude);
              text = "\u60A8\u5F53\u524D\u7684\u5730\u5740\u662F".concat(address, "\uFF0C\u8DDD\u79BB").concat(distance, "\u7C73");
            } else {
              distance = -1;
              text = '定位异常，是否开始服务？';
            }

            var params = {
              orderId: _this12.orderId,
              longitude: longitude,
              latitude: latitude,
              distance: distance,
              address: address
            };

            _this12.$vux.loading.hide();

            _this12.startOrEndService(startService, params, text, '开始服务');
          },
          onFail: function onFail(e) {
            var params = {
              orderId: _this12.orderId,
              longitude: 0,
              latitude: 0,
              distance: -1
            };

            _this12.$vux.loading.hide();

            _this12.startOrEndService(startService, params, '定位异常，是否开始服务？', '开始服务'); // this.$vux.toast.text('定位失败，请重试')
            // console.log(err)

          }
        });
        this.$point('ORD0024');
      } else if (name === 'addProcess') {
        if (this.orderServiceNodes.length === 0) {
          this.$vux.toast.text('没有需要填写的进度');
        } else {
          this.$router.push({
            name: 'WriteProgress',
            params: {
              orderId: this.orderId
            }
          });
        }
      } else if (name === 'editOrder') {
        this.getEditOrderDetailFunc();
      } else if (name === 'message') {
        if (this.user.isChargeUser !== 0) {
          this.messageShow = true;
        } else {
          this.showUpdate('不支持工单留言', '免费版本不支持工单留言，建议升级为VIP版本，客服热线0592-3278627');
        }
      } else if (name === 'tag') {
        if (this.user.isChargeUser !== 0) {
          this.tagShow = true;
        } else {
          this.showUpdate('不支持设置工单状态操作', "免费版本不支持设置工单状态操作，建议升级为VIP版本，客服热线0592-3278627'");
        }
      } else if (name === 'accept') {
        // 接收工单
        this.$vux.confirm.show({
          content: '<span>确认接收工单？</span>',
          onCancel: function onCancel() {},
          onConfirm: function onConfirm() {
            acceptOrder({
              orderId: _this12.orderId
            }).then(function (res) {
              if (res.success) {
                _this12.$vux.toast.text('接单成功');

                _this12.$emit('on-success');
              } else {
                _this12.$vux.toast.text(res.message);
              }
            });

            _this12.$point('ORD0021');
          }
        });
      } else if (name === 'callReceipt') {
        this.executeShow = true;
      } else if (name === 'finishOrder') {
        if (!this.isEndServiceL) {
          return;
        }

        this.isEndServiceL = false;

        if (this.orderInfo.abnormal_state === 1) {
          this.$vux.toast.text('异常工单无法完成服务');
          return false;
        }

        checkFinish({
          orderId: this.orderId
        }).then(function (res) {
          if (res.success && res.data) {
            if (_this12.orderInfo.is_sign_location === 0 || process.env.NODE_ENV === 'development') {
              var _params = {
                orderId: _this12.orderId,
                longitude: 0,
                latitude: 0,
                distance: -1
              };

              if (_this12.isServiceExamineState) {
                _this12.startOrEndService(applyEndService, _params, '是否结束服务？', '已提交完成申请，请耐心等待');
              } else {
                _this12.startOrEndService(finishOrder, _params, '是否结束服务？', '结束服务');
              }

              return;
            }

            _this12.$vux.loading.show({
              text: '定位中...'
            });

            _this12.$DingTalk.device.geolocation.get({
              targetAccuracy: 100,
              // 精度半径
              coordinate: 1,
              // 1 高德坐标 2 标准坐标（无address字段）
              withReGeocode: true,
              // 是否返回逆地理编码信息
              useCache: true,
              // 是否缓存（开启后2分钟内再次请求返回缓存信息）
              onSuccess: function onSuccess(_ref3) {
                var longitude = _ref3.longitude,
                    latitude = _ref3.latitude,
                    address = _ref3.address;

                _this12.$vux.loading.hide();

                var distance = -1;
                var text = '';

                if (longitude && latitude && address) {
                  // 获取客户经纬度
                  var customLatitude = _this12.orderInfo.custom_latitude;
                  var customLongitude = _this12.orderInfo.custom_longitude; // 计算距离

                  var PI = Math.PI;
                  var EARTH_RADIUS = 6378137.0;

                  var getRad = function getRad(d) {
                    return d * PI / 180.0;
                  };

                  var getDistance = function getDistance(lng1, lat1, lng2, lat2) {
                    if (lng2 === null || lng2 === '' || lng2 === 'null') {
                      return -1;
                    }

                    var radLat1 = getRad(lat1);
                    var radLat2 = getRad(lat2);
                    var a = radLat1 - radLat2;
                    var b = getRad(lng1) - getRad(lng2);
                    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
                    s = s * EARTH_RADIUS;
                    s = Math.round(s * 10000) / 10000.0;
                    s = Math.round(s);
                    return s;
                  };

                  distance = getDistance(customLongitude, customLatitude, longitude, latitude);
                  text = "\u60A8\u5F53\u524D\u7684\u5730\u5740\u662F".concat(address, "\uFF0C\u8DDD\u79BB").concat(distance, "\u7C73");
                } else {
                  distance = -1;
                  text = '定位异常，是否结束服务？';
                }

                var params = {
                  orderId: _this12.orderId,
                  longitude: longitude,
                  latitude: latitude,
                  distance: distance,
                  address: address
                };

                if (_this12.isServiceExamineState) {
                  _this12.startOrEndService(applyEndService, params, text, '已提交服务完成审批，请耐心等待');
                } else {
                  _this12.startOrEndService(finishOrder, params, text, '结束服务');
                }
              },
              onFail: function onFail(e) {
                var params = {
                  orderId: _this12.orderId,
                  longitude: 0,
                  latitude: 0,
                  distance: -1
                };

                _this12.$vux.loading.hide();

                if (_this12.isServiceExamineState) {
                  _this12.startOrEndService(applyEndService, params, '定位异常，是否结束服务？', '已提交服务完成审批，请耐心等待');
                } else {
                  _this12.startOrEndService(finishOrder, params, '定位异常，是否结束服务？', '结束服务');
                } // this.$vux.toast.text('定位失败，请重试')
                // console.log(err)

              }
            });
          } else {
            _this12.isEndServiceL = true;

            _this12.$vux.toast.text('还有未完成的进度, 请先完成进度');
          }
        });
      } else if (name === 'cc') {
        this.checkUserModal = true;
      } else if (name === 'editCount') {
        this.editCountShow = true;
      } else if (name === 'serviceAmount') {
        this.serviceAmountPopupShow = true;
      } else if (name === 'serviceEval') {
        this.evaluateShow = true;
      } else if (name === 'dealAbnormal') {
        this.dealAbnormalShow = true;
      } else if (name === 'orderExamine') {
        this.isShowExamineModal = true;
      } else if (name === 'putIntoGrab') {
        this.isShowPutIntoGrabModal = true;
      } else if (name === 'grab') {
        this.setOrdervisitUserGrab(this.orderInfo.orderId);
      } else if (name === 'revokeGrab') {
        this.setOrderRevokeGrab(this.orderInfo.orderId);
      }
    },
    // 抢单
    setOrdervisitUserGrab: function setOrdervisitUserGrab(oid) {
      var _this13 = this;

      _setOrdervisitUserGrab({
        oid: oid
      }).then(function (res) {
        if (res.success) {
          _this13.$vux.toast.text('恭喜您抢单成功');

          _this13.$emit('on-success');
        } else {
          _this13.$vux.toast.text(res.message);
        }
      });
    },
    // 捞回
    setOrderRevokeGrab: function setOrderRevokeGrab(oid) {
      var _this14 = this;

      this.$vux.confirm.show({
        content: '<span>确认捞回该工单？</span>',
        // 组件除show外的属性
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          _setOrderRevokeGrab({
            oid: [oid]
          }).then(function (res) {
            if (res.success) {
              _this14.$vux.toast.text('捞回成功');

              _this14.$emit('on-success');
            } else {
              _this14.$vux.toast.text(res.message);
            }
          });
        }
      });
    },
    // 开始/结束服务
    startOrEndService: function startOrEndService(method, params, confirmText, toastText) {
      var _this15 = this;

      this.$vux.confirm.show({
        content: "<span>".concat(confirmText, "</span>"),
        onCancel: function onCancel() {
          _this15.isStartService = true;
          _this15.isEndServiceL = true;
        },
        onConfirm: function onConfirm() {
          method(params).then(function (res) {
            _this15.$vux.loading.show({
              text: '加载中...'
            });

            if (res.success) {
              setTimeout(function () {
                _this15.$vux.loading.hide();
              }, 300);

              _this15.$vux.toast.text("".concat(toastText, "\u6210\u529F"));

              _this15.$emit('on-success');
            } else {
              setTimeout(function () {
                _this15.$vux.loading.hide();
              }, 300);

              _this15.$vux.toast.text(res.message);
            }

            _this15.isEndServiceL = true;
            _this15.isStartService = true;
          });
        }
      });
    },
    showUpdate: function showUpdate(title, content) {
      this.$vux.confirm.show({
        title: title,
        content: content,
        cancelText: '取消留言',
        confirmText: '立即升级',
        hideOnBlur: true,
        onShow: function onShow() {},
        onHide: function onHide() {},
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {}
      });
    },
    // 获取编辑工单详情
    getEditOrderDetailFunc: function getEditOrderDetailFunc() {
      var _this16 = this;

      var data = {
        tempId: this.orderInfo.orderTypeTmplId,
        orderId: this.orderInfo.orderId
      };
      getEditOrderDetail(data, this.user.sysrole === 4 ? 2 : 1).then(function (res) {
        if (res.success) {
          var obj = {};
          obj.systemField = res.data.order;
          obj.template = res.data.template;
          obj.fieldList = res.data.fieldList;
          obj.orderProduct = res.data.orderProduct;
          obj.productList = res.data.productList;
          obj.remarkPicList = res.data.remarkPicList;
          obj.itemList = res.data.itemList;
          obj.itemIsRequired = res.data.itemIsRequired;
          obj.extServiceItems = res.data.extServiceItems || [];
          obj.mainService = {
            name: obj.systemField.service_name,
            service_num: obj.systemField.service_num,
            serviceId: [obj.systemField.serviceId],
            offer_price: obj.systemField.offer_price,
            unit: obj.systemField.unit
          };
          _this16.formData = obj;
          _this16.createOrderPopupShow = true;
        }
      });
    },
    dealdata: function dealdata(data) {
      var _this17 = this;

      var vo = {};
      vo.oid = this.orderId;
      vo.ccUsers = [];
      data.forEach(function (item, index) {
        var ccUser = {};
        ccUser.id = item;
        vo.ccUsers.push(ccUser);
      });
      saveCCUsers(vo).then(function (res) {
        if (res.success) {
          _this17.$vux.toast.text('抄送成功');

          _this17.$emit('on-success');
        } else {
          _this17.$vux.toast.text(res.message);
        }
      });
      this.$point('ORD0017');
    },
    maketagSuccess: function maketagSuccess(taglist) {
      this.$emit('on-maketag', taglist);
      this.$point('ORD0019');
    },
    // 选择服务团队 回调
    dispatchClick: function dispatchClick(id) {
      var _this18 = this;

      updateOrderGroupId({
        orderId: this.orderId,
        groupId: id
      }).then(function (res) {
        if (res.success) {
          _this18.$vux.toast.text('转派成功');

          _this18.currValue = false;
        } else {
          _this18.$vux.toast.text(res.message);
        }
      });
      this.$point('ORD0009');
    },
    // 预约弹窗 确认
    appointmentOnConfirm: function appointmentOnConfirm() {
      var _this19 = this;

      var data = {
        orderId: this.orderId,
        bespokeDate: this.selecttime
      };
      workerBespokeDate(data).then(function (res) {
        if (res.success) {
          _this19.$vux.toast.text('预约成功');

          _this19.$emit('on-success');
        } else {
          _this19.$vux.toast.text(res.message);
        }
      });
      this.$point('ORD0023');
    },
    // 编辑款项用
    loadEditAmount: function loadEditAmount() {
      var _this20 = this;

      getServiceAmount({
        oid: this.orderId
      }).then(function (res) {
        if (res.success) {
          _this20.service = res.data.service;
          _this20.sparePartList = res.data.sparePartList;
          _this20.moneyItemList = res.data.moneyItemList;
          _this20.pics = res.data.pics;
        } else {
          _this20.$vux.toast.text(res.message);
        }
      });
    },
    showEvalPicClose: function showEvalPicClose() {
      this.showEvalPic = false;
    },
    // 审批
    examineOperation: function examineOperation(value, type) {
      var _this21 = this;

      if (type === 2 && value.trim() === '') {
        this.$vux.toast.text('请填写驳回原因');
        return;
      }

      var data = {
        oid: this.orderId,
        reason: value,
        agree: type
      };
      var examineType = {
        1: '审批通过',
        2: '审批驳回'
      };
      this.isShowExamineModal = false;
      this.$vux.loading.show();
      orderExamine(data).then(function (res) {
        _this21.$vux.loading.hide();

        if (res.success) {
          _this21.examineReason = '';

          _this21.$vux.toast.text(examineType[type]);

          _this21.$emit('on-success');
        } else {
          _this21.$vux.toast.text(res.message);
        }
      });
    },
    // 拒绝工单
    refuse: function refuse() {
      var _this22 = this;

      if (this.refuseRemark && this.refuseRemark !== '') {
        if (this.refuseRemark > 500) {
          this.$vux.toast.text('请输入500个以内汉字或字符');
          return;
        }

        refuseOrder({
          oid: this.orderId,
          remark: this.refuseRemark
        }).then(function (res) {
          if (res.success) {
            _this22.$vux.toast.text('拒绝工单成功');

            _this22.isShowRefuseOrderModal = false;
            _this22.refuseRemark = '';

            _this22.$emit('on-success');
          } else {
            _this22.$vux.toast.text(res.message);

            _this22.isShowRefuseOrderModal = false;
            _this22.refuseRemark = '';
          }
        });
        this.$point('ORD0022');
      } else {
        this.$vux.toast.text('拒绝原因必须填写');
      }
    }
  }),
  created: function created() {
    var _this23 = this;

    this.evalpic = "/order/completeScanImage?orderId=".concat(this.orderId);
    this.loadEditAmount();
    this.updateMenuList();
    getEnterprise({
      code: 10018
    }).then(function (res) {
      if (res.success) {
        _this23.isMainPersonEditCount = Boolean(+res.data.value);
      }
    });
    getEnterprise({
      code: 10019
    }).then(function (res) {
      if (res.success) {
        _this23.isCollaboratorEditCount = Boolean(+res.data.value);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$DingTalk && this.$DingTalk.biz.navigation.setRight({
      show: false
    });
  }
};